import { Link } from 'gatsby';
import React from 'react';
import Advantage from './Advantage';
import Domain from './Domain';
import Heading from './Heading';

// eslint-disable-next-line react/prop-types
const BillingUnit = ({ sku }) => {
  // const text = sku === 'GA21' ? '' : `/${getUnit(sku)}`;
  const text = sku === 'GA14' ? '/form' : '';
  return (
    <span className="ml-1 text-xl font-normal leading-8 text-gray-500">
      {text}/year
    </span>
  );
};

// eslint-disable-next-line react/prop-types
const BillingStyle = ({ sku }) => {
  // const text = sku === 'GA21' ? '' : `per ${getUnit(sku)},`;
  const text = sku === 'GA14' ? 'per form' : 'per user';
  return (
    <p className="mt-5 text-lg leading-7 text-gray-500">
      The price is {text}, billed annually
    </p>
  );
};

const Pricing = ({ plans }) => {
  const { sku, common, standard, enterprise } = plans;
  const buyLink = `/buy?sku=${sku}`;

  return (
    <div className="bg-indigo-700" id="pricing">
      <Heading />
      <div className="pb-12 mt-8 bg-gray-50 sm:mt-12 sm:pb-16 lg:mt-16 lg:pb-24">
        <div className="relative">
          <div className="absolute inset-0 bg-indigo-700 h-3/4" />
          <div className="relative z-10 max-w-screen-xl px-4 mx-auto sm:px-6 lg:px-8">
            <div className="max-w-md mx-auto lg:max-w-5xl lg:grid lg:grid-cols-2 lg:gap-5">
              <div className="overflow-hidden rounded-lg shadow-lg">
                <div className="px-6 py-8 bg-white sm:p-10 sm:pb-6">
                  <div>
                    <h3
                      className="inline-flex px-4 py-1 text-sm font-semibold leading-5 tracking-wide text-indigo-600 uppercase bg-indigo-100 rounded-full"
                      id="tier-standard"
                    >
                      {standard.name}
                    </h3>
                  </div>
                  <div className="flex items-baseline mt-4 text-6xl font-extrabold leading-none">
                    ${standard.price}
                    <BillingUnit sku={sku} />
                  </div>
                  <BillingStyle sku={sku} />
                </div>
                <div className="px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6">
                  <ul>
                    {[...common.features, ...standard.features].map(
                      (feature, index) => {
                        return (
                          <Advantage first={index === 0} key={feature}>
                            {feature}
                          </Advantage>
                        );
                      }
                    )}
                  </ul>
                  <div className="mt-6 rounded-md shadow">
                    <Link
                      to={buyLink}
                      className="flex items-center justify-center px-5 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-gray-900 border border-transparent rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      aria-describedby="tier-standard"
                    >
                      Upgrade
                    </Link>
                  </div>
                </div>
              </div>
              <div className="mt-4 overflow-hidden rounded-lg shadow-lg lg:mt-0">
                <div className="px-6 py-8 bg-white sm:p-10 sm:pb-6">
                  <div>
                    <h3
                      className="inline-flex px-4 py-1 text-sm font-semibold leading-5 tracking-wide text-indigo-600 uppercase bg-indigo-100 rounded-full"
                      id="tier-enterprise"
                    >
                      {enterprise.name}
                    </h3>
                  </div>
                  <div className="flex items-baseline mt-4 text-6xl font-extrabold leading-none">
                    ${enterprise.price}
                    <BillingUnit sku={sku} />
                  </div>
                  <BillingStyle sku={sku} />
                </div>
                <div className="px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6">
                  <ul>
                    {[...common.features, ...enterprise.features].map(
                      (feature, index) => {
                        return (
                          <Advantage first={index === 0} key={feature}>
                            {feature}
                          </Advantage>
                        );
                      }
                    )}
                  </ul>
                  <div className="mt-6 rounded-md shadow">
                    <Link
                      to={`${buyLink}&edition=E`}
                      className="flex items-center justify-center px-5 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-gray-900 border border-transparent rounded-md hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      aria-describedby="tier-enterprise"
                    >
                      Upgrade
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Domain link={`${buyLink}&buying_for=domain`} />
      </div>
    </div>
  );
};

export default Pricing;
